import React, { useEffect } from 'react'

function PageTitle({title=""}) {
  
  return (
    <div className=' relative overflow-hidden w-full mt-[50px]'>
         <div>
            <h2 className='text-[#222222] montserrat text-[48px] font-[600] text-center  max-[700px]:text-[38px] max-[500px]:text-[34px]'>{title}</h2>
         </div>
    </div>
  )
}

export default PageTitle